import { GET_PARENTS_PARAMS_REQUEST } from 'models';

export const GET_SEARCH_FEE_REQUEST: string = 'GET_SEARCH_FEE_REQUEST';

export const getSearchFeeRequest = (
  params?: GET_PARENTS_PARAMS_REQUEST | null
) => {
  return {
    type: GET_SEARCH_FEE_REQUEST,
    payload: { params },
  };
};
